$(document).on('turbo:load', function() {

  $('.resource-type').change(function() {
    const selectedType = $('.resource-type').val()
    const className = '.' + selectedType.replace(/_/g, "-");

    $('.video, .image, .url, .document').hide()
    $('.clear-url, .clear-file').val('')
    $(this).val(selectedType)
    $(className).show()
  });

  // Show the image selected
  $('.edit-thumbnail').change(function() {
    if (this.files && this.files[0]) {
      const reader = new FileReader();
      const thumbnailImg = $(this).closest('.editable-img').find('.thumbnail-img');
      reader.onload = function (e) {
        thumbnailImg.parent().find('svg').remove();
        thumbnailImg.attr('src', e.target.result);
      }
      reader.readAsDataURL(this.files[0]);
    }
  });

});
